import {
  Component,
  OnInit,
  HostListener,
  ViewChild,
  TemplateRef
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app.reducer';
import { AuthenticationService } from 'app/services';
import { hideSidebar } from 'app/redux/actions';
declare var $: any;

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  constructor(
    public router: Router,
    private store: Store<AppState>,
    private auth: AuthenticationService
  ) {}

  public isCollapsed = false;

  public innerWidth: any;
  public defaultSidebar: any;
  public showSettings = false;
  public showMobileMenu = false;
  public expandLogo = false;
  public hideFollowing: boolean;
  public sidebarVisible = false;

  options = {
    theme: 'light',
    dir: 'ltr',
    layout: 'vertical',
    sidebartype: 'mini-sidebar',
    sidebarpos: 'fixed',
    headerpos: 'fixed',
    boxed: 'full',
    navbarbg: 'skin5',
    sidebarbg: 'skin5',
    logobg: 'skin5'
  };

  // Logo() {
  //   this.expandLogo = !this.expandLogo;
  // }

  ngOnInit() {
    this.hideFollowing = false;

    this.store.select('ui').subscribe(({ visible }) => {
      this.sidebarVisible = visible;
      this.options.sidebartype = visible ? 'overlay' : 'mini-sidebar';
      this.defaultSidebar = this.options.sidebartype;
      this.handleSidebar();
    });

    // if (this.router.url === '/') {
    //   this.router.navigate(['/']);
    // }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.handleSidebar();
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (this.sidebarVisible) { this.closeSidebar(); }
  }

  closeSidebar() {
    this.showMobileMenu = false;
    this.store.dispatch(hideSidebar());
  }

  handleSidebar() {
    this.innerWidth = window.innerWidth;
    switch (this.defaultSidebar) {
      case 'full':
      case 'iconbar':
        if (this.innerWidth < 1170) {
          this.options.sidebartype = 'mini-sidebar';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      case 'overlay':
        this.options.sidebartype = this.defaultSidebar;
        break;

      default:
    }
  }

  toggleSidebarType() {
    switch (this.options.sidebartype) {
      case 'full':
      case 'iconbar':
        this.options.sidebartype = 'mini-sidebar';
        break;

      case 'overlay':
        this.showMobileMenu = !this.showMobileMenu;
        break;

      case 'mini-sidebar':
        if (this.defaultSidebar === 'mini-sidebar') {
          this.options.sidebartype = 'full';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }
}
